import moment from 'moment';
import { formatMsLong } from '../../libs/utils';
import { Component, createElement } from 'react';

type TCountdownTimerState = {
  ticks: number;
  expired: boolean;
  targetTimestamp: any;
};

type TCountdownTimerProps = {
  className?: string;
  style?: Object;
  formatter?: (ms: number) => any;
  onComplete?: Function;
  completed?: any;
  to: string;
  offsetDays?: number;
  tag?: string;
};

export default class CountdownTimer extends Component<TCountdownTimerProps, TCountdownTimerState> {
  private interval: any;
  private formatter: any;

  public constructor(props: any, ctx: any) {
    super(props, ctx);
    this.state = {
      ticks: 0,
      expired: false,
      targetTimestamp: null
    };
  }

  public render() {
    if (!this.state.targetTimestamp) {
      return null;
    }

    const delta = moment.duration(this.state.targetTimestamp.diff(this.getNowTime()));
    if (delta.asSeconds() <= 0) {
      return this.props.completed ? this.props.completed : null;
    }

    return createElement(
      this.props.tag || 'div',
      {
        style: this.props.style || {},
        className: this.props.className || ''
      },
      this.formatter(delta.asMilliseconds())
    );
  }

  public componentDidMount() {
    this.formatter = this.props.formatter || this.defaultFormatter;
    this.interval = setInterval(this.tick, 1000);
    this.setState({
      targetTimestamp: moment.utc(this.props.to)
    });
  }

  public componentDidUpdate(prevProps: TCountdownTimerProps) {
    // Update formatter if changed
    if (prevProps.formatter !== this.props.formatter) {
      this.formatter = this.props.formatter || this.defaultFormatter;
    }

    // Reset interval and update timestamp if 'to' prop changed
    if (prevProps.to !== this.props.to) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(this.tick, 1000);
      this.setState({
        targetTimestamp: moment.utc(this.props.to),
        expired: false
      });
    }
  }

  public componentWillUnmount() {
    clearInterval(this.interval);
    this.interval = null;
  }

  private defaultFormatter = (ms: any) => {
    return formatMsLong(ms);
  };

  private getNowTime = () => {
    return this.props.offsetDays ? moment.utc().add(this.props.offsetDays, 'days') : moment.utc();
  };

  private tick = () => {
    this.setState({ ticks: this.state.ticks + 1 });
    if (!this.state.expired && this.state.targetTimestamp) {
      const delta = moment.duration(this.state.targetTimestamp.diff(this.getNowTime()));
      if (delta.asSeconds() <= 0) {
        this.setState({ expired: true });
        clearInterval(this.interval);
        if (this.props.onComplete) {
          this.props.onComplete();
        }
        this.interval = null;
      }
    }
  };
}
